/**
 * Vue mixin for hCaptcha validation basis.
 */

import VueHcaptcha from '@hcaptcha/vue3-hcaptcha';
import globals from '../../lib/globals';

export default {
  components: {
    VueHcaptcha
  },
  data() {
    return {
      hCaptcha: {
        sitekey: globals.hCaptchaSitekey,
        verified: false,
        expired: false,
        token: null,
        eKey: null,
        error: null,
      }
    }
  },
  methods: {
    onVerify(token, ekey) {
      this.hCaptcha.verified = true;
      this.hCaptcha.token = token;
      this.hCaptcha.eKey = ekey;
    },
    onExpire() {
      this.hCaptcha.verified = false;
      this.hCaptcha.token = null;
      this.hCaptcha.eKey = null;
      this.hCaptcha.expired = true;
    },
    onChallengeExpire() {
      this.hCaptcha.verified = false;
      this.hCaptcha.token = null;
      this.hCaptcha.eKey = null;
      this.hCaptcha.expired = true;
    },
    onError(err) {
      this.hCaptcha.token = null;
      this.hCaptcha.eKey = null;
      this.hCaptcha.error = err;
    },
    onSubmit() {
      this.$refs.invisibleHcaptcha.execute();
    },
    async onAsyncExecute() {
      const res = await this.$refs.asyncExecuteHCaptcha.executeAsync();
    },
  }
}
